<script setup>
import { onMounted, ref } from "vue";
import { getTranslation } from "../src/js/helpers/translations";
let posts = ref([]);
let categories = ref([]);
let params = ref({
    page: 1,
    sTerm: '',
    category: '',
    order: ''
});
let category = ref('not-selected');
let sTerm = ref('');
let page = ref(1);
let active = ref('');
let order = ref('not-selected');
const translations = getTranslation(getLangCode);
async function fetchData() {
    try {
        let postsUrl = new URL(MyScriptVars.rest_url + 'posts');
        Object.keys(params.value).forEach(key => postsUrl.searchParams.append(key, params.value[key]));
        const postsResponse = await fetch(postsUrl, {
            method: 'GET',
            credentials: 'same-origin',
            headers: new Headers({
                'X-WP-Nonce': MyScriptVars.nonce
            })
        });
        if (!postsResponse.ok) throw new Error('Network response was not ok for categories');
        posts.value = await postsResponse.json();
        console.log('faqs', faqs.value);

    } catch (error) {
        console.error('Fetch operation failed:', error);
    }
}
const setPage = () => {
    console.log(page.value);
    page.value++;
    console.log(page.value);
    loadMore();

}
const filterProperties = async () => {
    page.value = 1;
    try {
        const changeUrl = setUrl();
        const postsResponse = await fetch(changeUrl, {
            method: 'GET',
            credentials: 'same-origin',
            headers: new Headers({
                'X-WP-Nonce': MyScriptVars.nonce
            })
        });
        if (!postsResponse.ok) throw new Error('Network response was not ok for properties');
        posts.value = await postsResponse.json();
    } catch (e) {
        console.log(e);
    }
}
const loadMore = async () => {
    try {
        const changeUrl = setUrl();
        const faqResponse = await fetch(changeUrl, {
            method: 'GET',
            credentials: 'same-origin',
            headers: new Headers({
                'X-WP-Nonce': MyScriptVars.nonce
            })
        });
        if (!faqResponse.ok) throw new Error('Network response was not ok for properties');
        const data = await faqResponse.json();
        posts.value.posts = [...posts.value.posts, ...data.posts];
    } catch (e) {
        console.log(e);
    }
}
const setUrl = () => {
    const categoryValue = category.value !== 'not-selected' ? category.value : '';
    const orderValue = order.value !== 'not-selected' ? order.value : '';
    params.value = {
        page: page.value,
        category: categoryValue,
        sTerm,
        order: orderValue,
    };
    let changeUrl = new URL(MyScriptVars.rest_url + 'posts');
    Object.keys(params.value).forEach(key => changeUrl.searchParams.append(key, params.value[key]));

    return changeUrl;
}
onMounted(async () => {
    await fetchData();
});
</script>

<template>
    <section class="filters-section">
        <div class="container-3">
            <div class="filters-wrap grid">
                <div class="filter-item">
                    <label class="label-1">
                        {{ translations.category }}
                    </label>
                    <select v-model="category" class="input-1">
                        <option value="not-selected" selected>
                            {{ translations.select }}
                        </option>
                        <option v-for="category in posts.category" :value="category.term_id">
                            {{ category.name }}
                        </option>
                    </select>
                </div>
                <div class="filter-item">
                    <label class="label-1">
                        {{ translations.sort_by }}
                    </label>
                    <select name="prezzo" class="input-1" v-model="order">
                        <option value="not-selected">{{ translations.select }}</option>
                        <option value="popular">{{ translations.popular }}</option>
                        <option value="newest">{{ translations.newest }}</option>
                        <option value="oldest">{{ translations.oldest }}</option>
                    </select>
                </div>
                <div class="filter-item">
                    <label class="label-1">
                        {{ translations.search_word }}
                    </label>
                    <input v-model="sTerm" type="text" class="input-1">
                </div>
                <div class="filter-item">
                    <button @click.prevent="filterProperties()" type="submit" class="btn-1 full-width">
                        {{ translations.search }}
                    </button>
                </div>
            </div>
        </div>
    </section>
    <section class="blog-grid-section">
        <div class="faq-intro center m-20"><h1 class="section-title title-2"> Blog </h1></div>
        <div class="container-3">
            <div class="blog-grid grid">
                <a v-for="single in posts.posts" :href="single.permalink" class="blog-grid-item">
                    <div class="blog-grid-pic relative overflow m-15">
                        <img :src="single.image" class="object-fit-cover" alt="">
                    </div>
                    <div class="blog-grid-content">
                        <p class="blog-grid-title m-15">
                            {{ single.title  }}
                        </p>
                        <p class="blog-grid-text">
                            {{ single.description }}
                        </p>
                    </div>
                </a>
            </div>
        </div>
        <div v-if="posts.count >= 12" class="btn-wrapper-faq">
            <a href="#" @click.prevent="setPage" rel="noreferrer" class="btn-1 no-properties">{{ translations.show_more }}</a>
        </div>
    </section>
</template>

<style scoped>

</style>